import { createAction, props } from '@ngrx/store';


export const followPrediction = createAction(
  '[Follow Prediction] Follow Prediction',
  props<{ predictionId: string;  userId : string }>()
);
export const followPredictionSuccess = createAction(
  '[Follow Prediction] Follow Prediction Success',
  props<{ predictionId: string, userId : string, id : string }>()
);
export const followPredictionFailure = createAction(
  '[Follow Prediction] Follow Prediction Failure',
  props<{ error: any }>()
);
export const unfollowPrediction = createAction(
  '[Unfollow Prediction] Unfollow Prediction',
  props<{ predictionId: string, userId : string }>()
);
export const unfollowPredictionSuccess = createAction(
  '[Unfollow Prediction] Unfollow Prediction Success',
  props<{ predictionId: string, userId: string }>()
);
export const unfollowPredictionFailure = createAction(
  '[Unfollow Prediction] Unfollow Prediction Failure',
  props<{ error: any }>()
);
export const loadFollowedPredictions = createAction(
  '[Follow Prediction] Load Followed Predictions',
  props<{ userId: string }>()
);
export const loadFollowedPredictionsSuccess = createAction(
  '[Follow Prediction] Load Followed Predictions Success',
  props<{ predictions: any[] }>()
);
export const loadFollowedPredictionsFailure = createAction(
  '[Follow Prediction] Load Followed Predictions Failure',
  props<{ error: any }>()
);
